import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from '~/lib/ui/select'
import { useTranslation } from '../../hooks/useTranslation'

const GeneralForm = () => {
  const {
    uiState,
    setUiState,
    generalInterviewLevels,
    generalInterviewCategories,
  } = usePracticeInterviewing()

  const { t } = useTranslation('GeneralForm')

  const handleUpdate = (value, type) => {
    setUiState((prev) => ({
      ...prev,
      interviewParams: { ...prev.interviewParams, [type]: value },
    }))
  }

  return (
    <div className="flex flex-col pb-8">
      <h2>{t('title')}</h2>
      <p>{t('description')}</p>
      <div className="flex flex-col pb-8">
        <label htmlFor="level">{t('levels_label')}:</label>
        <Select
          id="level"
          onValueChange={(value) => handleUpdate(value, 'level')}
          value={
            uiState.interviewParams['level']
              ? uiState.interviewParams['level']
              : generalInterviewLevels[0]
          }
          defaultValue={generalInterviewLevels[0]}
        >
          {/* CTS-9240 */}
          <SelectTrigger aria-label={t('levels_label')}>
            <SelectValue placeholder="Please select a level" />
          </SelectTrigger>
          <SelectContent>
            {generalInterviewLevels.map((level, idx) => (
              <SelectItem key={idx} value={level}>
                {level}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col pb-8">
        <label htmlFor="category">{t('categories_label')}:</label>
        <Select
          id="category"
          onValueChange={(value) => handleUpdate(value, 'category')}
          value={
            uiState.interviewParams['category']
              ? uiState.interviewParams['category']
              : generalInterviewCategories[0]
          }
          defaultValue={generalInterviewCategories[0]}
        >
          {/* CTS-9240 */}
          <SelectTrigger aria-label={t('categories_label')}>
            <SelectValue placeholder="Please select a category" />
          </SelectTrigger>
          <SelectContent>
            {generalInterviewCategories.map((category, idx) => (
              <SelectItem key={idx} value={category}>
                {category}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col pb-8">
        <label htmlFor="questions">{t('number_of_questions_label')}:</label>
        <Select
          id="questions"
          onValueChange={(value) => handleUpdate(value, 'number_of_questions')}
          value={
            uiState.interviewParams['number_of_questions']
              ? uiState.interviewParams['number_of_questions']
              : 1
          }
          defaultValue={1}
        >
          {/* CTS-9240 */}
          <SelectTrigger aria-label={t('number_of_questions_label')}>
            <SelectValue placeholder="Please select a number of questions" />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 10 }, (_, i) => i + 1).map((num, idx) => (
              <SelectItem key={idx} value={num}>
                {num}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}

export default GeneralForm
